import React from 'react';
import OurResultsData from 'components/OurResultsData';
import StaticContainer from 'components/StaticContainer';

const OurResults = () => (
  <div>
    <StaticContainer>
      <OurResultsData />
    </StaticContainer>
  </div>
);

export default OurResults;




// WEBPACK FOOTER //
// ./src/containers/OurResults/OurResults.js